import axiosIns from '../../../../xaxios';
import {  obtenerUrlAPICalificaciones } from '../utils/funciones';
/**
 * @typedef {import('../interfaces/solicitud-modificacion-calificacion.Interfaces').FiltrosSolicitudesInterface} FiltrosSolicitudesInterface
 */
const recurso = 'portal-solicitudes-modificaciones-calificaciones';

export default {

  /**
   * @param {FiltrosSolicitudesInterface} filtros
   */
  async solicitudes(filtros) {
    // console.log('filtros servicio', filtros);
    // eslint-disable-next-line no-console
    console.log(filtros);
    return await axiosIns.get(obtenerUrlAPICalificaciones(`${recurso}/solicitudes`), { params: filtros });
  },

 /**
   * @param {number} solicitudId
   */
  async verSolicitudPDF(solicitudId) {
    // console.log('filtros servicio', filtros);
    // eslint-disable-next-line no-console
    // console.log(filtros);
    return await axiosIns.get(obtenerUrlAPICalificaciones(`${recurso}/solicitud-pdf/${solicitudId}`), { responseType: 'blob' });
  },



  async revisarSolicitud(revisarSolicitudInput) {
    // console.log('filtros servicio', filtros);
    // eslint-disable-next-line no-console
    // console.log(filtros);
    return await axiosIns.post(obtenerUrlAPICalificaciones(`${recurso}/revisar-solicitud`), revisarSolicitudInput);
  },
};
